var React = require('react');

function At (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM4,5.7","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM10.7,8c0,2.2-1.2,4-2.7,4s-2.7-1.8-2.7-4S6.5,4,8,4S10.7,5.8,10.7,8z","key":1}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM10.7,8L10.7,8c0,2,2.3,4.6,3.8,3.1c0.5-0.5,0.9-2.4,0.9-3.1c0-4.1-3.4-7.4-7.5-7.4C4,0.7,0.7,4,0.6,7.9C0.6,12,3.9,15.4,8,15.4\n\t\tc1.5,0,3-0.5,4.1-1.3","key":2})]));
}

At.displayName = "At";

At.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = At;

At.default = At;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/at.svg
// module id = ../icon/src/icons/at.svg
// module chunks = 0